export default function Categories() {
  const features = [
    {
      icon: 'ri-palette-line',
      title: '10 Cores Vibrantes',
      description: 'Escolha entre preto, azul, vermelho, branco, rosa, verde, amarelo, lilás, cinza e laranja',
      color: 'from-orange-500 to-pink-500'
    },
    {
      icon: 'ri-star-smile-line',
      title: 'Pins Decorativos',
      description: 'Cada Crocs vem com pins variados: personagens, símbolos, ícones e temas divertidos',
      color: 'from-pink-500 to-yellow-500'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Conforto Garantido',
      description: 'Material de qualidade, leve e durável para uso diário com máximo conforto',
      color: 'from-yellow-500 to-orange-500'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Preço Fixo',
      description: 'Todos os modelos por apenas 1.800 MZN, sem variação de preço',
      color: 'from-green-500 to-teal-500'
    }
  ];

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-sm text-orange-600 font-semibold mb-2">• Por Que Escolher</p>
          <h2 className="text-6xl font-bold text-gray-900 mb-4">Nossos Diferenciais</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Crocs personalizados com estilo único, qualidade superior e preço acessível
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer"
            >
              <div className={`w-16 h-16 flex items-center justify-center bg-gradient-to-br ${feature.color} rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <button
            onClick={() => window.open('https://wa.me/258869689262?text=Olá! Gostaria de ver os modelos disponíveis.', '_blank')}
            className="inline-flex items-center gap-3 px-10 py-5 bg-gradient-to-r from-orange-500 to-pink-500 text-white text-lg font-semibold rounded-full hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Ver Todos os Modelos
            <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-full">
              <i className="ri-arrow-right-line text-xl"></i>
            </div>
          </button>
        </div>
      </div>
    </section>
  );
}
